import { useCallback, useEffect, useState } from "react";

import { SearchStandardsResponse } from "../../service/publicquery";
import { searchStandards } from "../../service/publicquery/PublicQueryService.full";

interface UsePublicProjectTypesAndCodeTemplateReturnData {
  standards: SearchStandardsResponse["results"];
  projectTypes: SearchStandardsResponse["results"][0]["projectTypes"];
  isLoading: boolean;
}
export const usePublicProjectTypesAndCodeTemplate = (): UsePublicProjectTypesAndCodeTemplateReturnData => {
  const [standards, setStandards] = useState<SearchStandardsResponse["results"]>([]);
  const [projectTypes, setProjectTypes] = useState<SearchStandardsResponse["results"][0]["projectTypes"]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(async (): Promise<void> => {
    const response = await searchStandards({
      paging: {
        afterCursor: null,
        beforeCursor: null,
        limit: 10,
      },
      filter: {
        results: {
          description: {
            operator: "startsWith",
            value: "",
          },
        },
      },
    });
    setStandards(
      response.data?.results.map((s) => ({
        ...s,
        projectTypes: s.projectTypes.filter((pt) => pt.description) ?? [],
      })) ?? []
    );

    setProjectTypes(
      Array.from(
        new Map(
          (response.data?.results ?? [])
            .flatMap((s) => s.projectTypes ?? [])
            .filter((pt) => pt.description)
            .map((pt) => [pt.uuid, pt])
        ).values()
      )
    );
  }, []);

  useEffect(() => {
    fetchData().then(() => setIsLoading(false));
  }, []);
  return {
    standards,
    projectTypes,
    isLoading,
  };
};
